
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { CouchbaseLinkedService } from 'app/model/linkedservice/couchbase.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'CouchbaseTable',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Couchbase_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Couchbase_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: CouchbaseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class CouchbaseTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
